import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Camera, Maximize2 } from "lucide-react";
import { useLightbox } from "./Lightbox";

export const Placeholder = ({ label, src, className = "", parallax = false, testId }) => {
  const ref = useRef(null);
  const lightbox = useLightbox();
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], parallax ? [-14, 14] : [0, 0]);

  return (
    <div
      ref={ref}
      data-testid={testId}
      onClick={src ? () => lightbox?.open(src, label) : undefined}
      className={`relative overflow-hidden bg-surface border border-line/70 group ${src ? "cursor-zoom-in" : "shimmer-sweep"} ${className}`}
    >
      {src ? (
        <motion.img
          src={src}
          alt={label || "The Old Pub"}
          loading="lazy"
          style={{ y, scale: parallax ? 1.06 : 1 }}
          className="absolute inset-0 w-full h-full object-cover"
        />
      ) : (
        <motion.div style={{ y }} className="absolute inset-0 placeholder-grid" />
      )}

      {/* hover zoom affordance */}
      {src && (
        <div className="absolute inset-0 z-[15] flex items-center justify-center bg-bg/0 group-hover:bg-bg/25 transition-colors duration-300 pointer-events-none">
          <span className="w-12 h-12 rounded-full bg-bg/70 border border-primary/40 flex items-center justify-center opacity-0 scale-90 group-hover:opacity-100 group-hover:scale-100 transition-all duration-300">
            <Maximize2 className="w-4 h-4 text-primary" />
          </span>
        </div>
      )}

      {/* corner ticks */}
      <span className="absolute top-3 left-3 w-4 h-4 border-t border-l border-primary/50 z-10" />
      <span className="absolute top-3 right-3 w-4 h-4 border-t border-r border-primary/50 z-10" />
      <span className="absolute bottom-3 left-3 w-4 h-4 border-b border-l border-primary/50 z-10" />
      <span className="absolute bottom-3 right-3 w-4 h-4 border-b border-r border-primary/50 z-10" />

      {src ? (
        label && (
          <div className="absolute inset-x-0 bottom-0 z-10 bg-gradient-to-t from-bg/85 via-bg/30 to-transparent px-6 pt-16 pb-6">
            <span className="font-mono text-[10px] uppercase tracking-ultra text-primary">
              {label}
            </span>
          </div>
        )
      ) : (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 px-6 text-center">
          <Camera className="w-5 h-5 text-primary/60" strokeWidth={1.4} />
          <span className="font-mono text-[10px] md:text-xs uppercase tracking-ultra text-primary/70">
            Image Coming Soon
          </span>
          {label && (
            <span className="font-serif text-lg md:text-2xl text-textMuted/80 italic">
              {label}
            </span>
          )}
        </div>
      )}
    </div>
  );
};
